import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseOrderService } from '../../pages/purchase-order/purchase-order-service';
export interface PeriodicElement {
  position?: any;
  heading: any;
  description: any;
}
@Component({
  selector: 'app-terms-condition-dialog',
  templateUrl: './terms-condition-dialog.component.html',
  styleUrls: ['./terms-condition-dialog.component.scss']
})
export class TermsConditionDialogComponent implements OnInit {
  public otherChargesForm: UntypedFormGroup;
  public displayedColumns = ['select', 'position', 'heading', 'description'];
  dataSource = new MatTableDataSource<PeriodicElement>();
  selection = new SelectionModel<PeriodicElement>(true, []);
  constructor(
    public dialogRef: MatDialogRef<TermsConditionDialogComponent>,
    private poService: PurchaseOrderService
  ) { }

  ngOnInit(): void {
    this.getAllTerms();
  }

  getAllTerms() {
    this.poService.getAllTermsByType("ALL").subscribe(res => {
    this.dataSource.data = res;
    })
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }
  checkboxLabel(row?: PeriodicElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
  save() {
    this.dialogRef.close(this.selection.selected);
  }
  close(): void {
    this.dialogRef.close();
  }
}
